import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../../httpClient/serverApi/types/IResponse';

export interface IGetSiteSAMLSiteLevelAuthValuesResult extends IResult {
  authenticationSettingForEmbeddedViz?: string;
  allowEmbeddedAuthenticationForEmbeddedVizzes?: boolean;
}

export class GetSiteSAMLSiteLevelAuthValuesRequest extends Request<{}, IGetSiteSAMLSiteLevelAuthValuesResult> {
  constructor() {
    super('getSiteLevelAuthValues', null);
  }
}
